// Configurare URL API
export const API_BASE_URL = 'http://ai.krakiun.com';
// export const API_BASE_URL = 'http://localhost:8000';

// Servicii pentru autentificare
export const loginUser = async (username, password) => {
  const formData = new FormData();
  formData.append('username', username);
  formData.append('password', password);

  const response = await fetch(`${API_BASE_URL}/token`, {
    method: 'POST',
    body: formData,
  });

  if (!response.ok) {
    const data = await response.json();
    throw new Error(data.detail || 'Autentificare eșuată');
  }

  const data = await response.json();
  return data;
};

export const registerUser = async (username, email, password) => {
  const response = await fetch(`${API_BASE_URL}/register`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      username,
      email,
      password,
    }),
  });

  if (!response.ok) {
    const data = await response.json();
    throw new Error(data.detail || 'Înregistrare eșuată');
  }

  return await response.json();
};

export const getCurrentUser = async (token) => {
  const response = await fetch(`${API_BASE_URL}/users/me`, {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  });
  
  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }
  
  return await response.json();
};

// Servicii pentru conversații
export const getConversations = async (token) => {
  console.log("DEBUG - Apelăm endpoint-ul /conversations");
  
  const response = await fetch(`${API_BASE_URL}/conversations`, {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  });
  
  if (!response.ok) {
    console.error(`Eroare la preluarea conversațiilor: ${response.status}`);
    throw new Error(`HTTP error! status: ${response.status}`);
  }
  
  const data = await response.json();
  console.log(`DEBUG - Am primit ${data.length} conversații de la server`);
  console.log("DEBUG - Răspuns complet de la /conversations:", data);
  
  return data;
};

export const getConversation = async (token, conversationId) => {
  const response = await fetch(`${API_BASE_URL}/conversations/${conversationId}`, {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  });
  
  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }
  
  return await response.json();
};

export const createConversation = async (token, modelId = null, isPrivate = false) => {
  // Debug
  console.log(`DEBUG - Apel createConversation cu modelId: ${modelId}, isPrivate: ${isPrivate}, tip isPrivate: ${typeof isPrivate}`);
  
  // Construim parametrii pentru query
  let params = [];
  
  // Dacă avem un model specificat, îl adăugăm la parametri
  if (modelId) {
    params.push(`model_id=${encodeURIComponent(modelId)}`);
  }
  
  // Adăugăm parametrul private dacă este setat
  if (isPrivate) {
    // Adăugăm explicit ca 'true', nu ca true (boolean) care ar putea fi convertit greșit
    params.push('private=true');
    console.log('DEBUG - Adăugăm parametrul private=true');
  } else {
    // Adăugăm explicit 'false' pentru debugging și claritate
    params.push('private=false');
    console.log('DEBUG - Adăugăm parametrul private=false');
  }
  
  // Construim URL-ul cu parametrii
  const queryString = params.length > 0 ? `?${params.join('&')}` : '';
  
  // Debug
  console.log(`DEBUG - URL pentru createConversation: ${API_BASE_URL}/conversations${queryString}`);
  
  const response = await fetch(`${API_BASE_URL}/conversations${queryString}`, {
    method: 'POST',
    headers: {
      'Authorization': `Bearer ${token}`
    }
  });
  
  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }
  
  const data = await response.json();
  
  // Debug
  console.log(`DEBUG - Răspuns de la createConversation:`, data);
  console.log(`DEBUG - Valoarea flag-ului private în răspuns: ${data.private}`);
  
  return data;
};

export const deleteConversation = async (token, conversationId) => {
  const response = await fetch(`${API_BASE_URL}/conversations/${conversationId}`, {
    method: 'DELETE',
    headers: {
      'Authorization': `Bearer ${token}`
    }
  });
  
  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }
  
  return true;
};

// Servicii pentru modele
export const getModels = async (token) => {
  const response = await fetch(`${API_BASE_URL}/models`, {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  });
  
  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }
  
  return await response.json();
};

// Verificare stare backend
export const checkBackendStatus = async () => {
  try {
    const response = await fetch(`${API_BASE_URL}/`);
    return response.ok;
  } catch (error) {
    return false;
  }
}; 